import React, { useContext, useEffect } from "react";
import QuestionsForm from "./QuestionsForm";
import { MenuContext } from "../../App";

function About() {
  const [isMenuClicked, setIsMenuClicked] = useContext(MenuContext);
  
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setIsMenuClicked(!isMenuClicked);
  },[]);

  return (
    <div className="w-full py-2 md:py-10 flex flex-col justify-start items-center">
      <div className="w-full relative text-center">
        <img src="About/team.jpg" alt="Team" />
        <h1 className="absolute tracking-wider top-10 left-1/2 -translate-x-1/2 text-5xl md:text-9xl animate__animated animate__zoomInDown">
          Our Company
        </h1>
      </div>

      <div className="w-4/5 text-center py-20">
        <h2 className="text-3xl md:text-6xl drop-shadow-xl">
          "We bridge the gap between technology and possibility."
        </h2>
      </div>

      <div className="w-11/12 flex flex-col gap-y-10">
        <div className="w-full flex gap-x-2">
          <div className="w-1/2 flex justify-center items-center">
            <img
              src="About/team1.jpg"
              alt=""
              className="rounded-full shadow-xl shadow-black"
            />
          </div>
          <div className="w-1/2 p-2 md:p-10 gap-y-5 tracking-wide flex flex-col justify-center">
            <h3 className="text-xl md:text-3xl">
              Technologists at heart with a focus on business value
            </h3>
            <p className="text-cyan-500 text-base md:text-lg">
              We've been in India for more than 10 years. Our company was
              founded by technology industry experts focused on solutions that
              were best for our customers, and we haven't lost that mindset.{" "}
            </p>
          </div>
        </div>
        <div className="w-full flex gap-x-2">
          <div className="w-1/2 p-2 md:p-10 gap-y-5 tracking-wide flex flex-col justify-center">
            <h3 className="text-xl md:text-3xl">How are we unique?</h3>
            <p className="text-cyan-500 text-base md:text-lg">
              Over the years, we've worked with a growing number of
              organizations across all industries to solve their unique business
              challenges—from orchestrating simple O365 migration and backup
              engagements to architecting and implementing complex
              infrastructure to designing the best CloudSmart solutions. As our
              customers business needs continue to evolve, so do we. One thing
              we guarantee will never change is our commitment and service to
              you.{" "}
            </p>
          </div>{" "}
          <div className="w-1/2 flex justify-center items-center">
            <img
              src="About/team2.jpg"
              alt=""
              className="rounded-full shadow-xl shadow-black"
            />
          </div>
        </div>
        <div className="w-full flex gap-x-2">
          <div className="w-1/2 flex justify-center items-center">
            <img
              src="About/team3.jpg"
              alt=""
              className="rounded-full shadow-xl shadow-black"
            />
          </div>
          <div className="w-1/2 md:p-10 gap-y-5 text-lg tracking-wide flex flex-col justify-center">
            <h3 className="text-xl md:text-3xl">
              We think about things differently
            </h3>
            <p className="text-cyan-500 text-base md:text-xl">
              Our goal is to help you move forward faster, leveraging the value
              you get from your IT infrastructure investments. We think about
              how to architect in the right cloud platform for each of your IT
              services. When doing that, we also think about the most simplified
              way to deliver a singular architecture that maximizes flexibility
              and minimizes cost.{" "}
            </p>
          </div>
        </div>
      </div>

      <div className="w-full py-10">
        <div className="w-full py-5 flex justify-center items-center bg-black bg-opacity-50">
          <div className="w-2/3 py-5 gap-y-5 flex flex-col items-center">
            <h3 className="text-3xl tracking-wider">Questions?</h3>
            <QuestionsForm />
          </div>
        </div>
      </div>

      <div className="w-full text-3xl md:text-6xl flex justify-center animate__animated animate__tada">
        Thank You for visiting our website!!
      </div>
    </div>
  );
}

export default About;
